export class Login
{
  username: string;
  password: string;
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/loginmodel.ts